export const QuestionActions = {
  FETCH_QTYPE_REQUEST: 'FETCH_QTYPE_REQUEST',
  FETCH_QTYPE_SUCCESS: 'FETCH_QTYPE_SUCCESS',
  FETCH_QTYPE_FAILURE: 'FETCH_QTYPE_FAILURE',
  // define other action types here
};